import {
  Flex,
  Link,
  Modal,
  Typography /** Media query result is used within a client-only modal; this is safe to use. */,
  // eslint-disable-next-line no-restricted-imports
  useMobileMediaQuery,
} from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import { ClientOnly } from '@jane/bloom/components/clientOnly';

import styles from './modalSection.module.css';

type ModalSectionProps = {
  children?: ReactNode;
  deselectFilters: () => void;
  filterLabel: string;
  shouldShowDeselectOption?: boolean;
  shouldShowDividerBelow?: boolean;
};

export function ModalSection({
  children,
  deselectFilters,
  filterLabel,
  shouldShowDeselectOption = true,
  shouldShowDividerBelow = true,
}: ModalSectionProps) {
  const isMobile = useMobileMediaQuery({});
  return (
    <>
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="baseline"
        mb={16}
      >
        <Typography
          className={styles['sectionHeader']}
          variant={isMobile ? 'body-regular' : 'h2-semibold'}
        >
          {filterLabel}
        </Typography>
        {shouldShowDeselectOption && (
          <Link
            onClick={deselectFilters}
            color="text-main"
            className={styles['sectionHeader__link']}
          >
            Deselect all
          </Link>
        )}
      </Flex>
      {children}
      {shouldShowDividerBelow && (
        <ClientOnly>
          {() => <Modal.ContentDivider height={16} color="grays-ultralight" />}
        </ClientOnly>
      )}
    </>
  );
}
